<form class="flex flex-column" (validate)="save()" novalidate validation-es>
  <ms-common-person-form name="personForm" [(ngModel)]="person"></ms-common-person-form>

  <div class="col-12 px-0 pb-0 pt-3 align-items-center flex flex-wrap" *ngIf="!doctor.id">
    <label class="col-12 md:col-3 px-0 py-0 m-0" for="username">{{screen.labels.user}}</label>
    <div class="col-12 md:col-9 px-0 py-0 inline-flex flex-wrap">
      <span class="col-12 md:col-6 py-1 md:py-0 px-0 md:px-2">
        <input pInputText type="text" name="username" [(ngModel)]="doctor.username" class="no-margin" autocomplete="off"
          [placeholder]="screen.labels.userPlaceholder" validation [required]="true" />
      </span>
    </div>
  </div>

  <hr>

  <ms-common-doctor-form name="doctorModel" [(ngModel)]="doctor"></ms-common-doctor-form>

  <hr>

  <div class="align-self-end">
    <button pButton type="submit" [label]="screen.actions.save" [loading]="loading" icon="far fa-save" iconPos="left"
      class="p-button-success p-button-outlined"></button>
  </div>
</form>